var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-marketing text-white rounded px-2 py-1 inline-block uppercase text-xs leading-4 font-bold"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }